import { render, staticRenderFns } from "./EmptyFontIcon.vue?vue&type=template&id=1366e3c8&"
import script from "./EmptyFontIcon.vue?vue&type=script&lang=js&"
export * from "./EmptyFontIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports